import { useCallback, useEffect, useState } from "react";

/**
 * Mount/unmount lifecycle for CSS-transition-driven overlays.
 * The DOM stays mounted during the exit transition; `active` flips one
 * frame after mount so the browser paints the closed state first.
 */
export function useTransitionMount(open: boolean, nodeRef: { current: HTMLElement | null }) {
  const [mounted, setMounted] = useState(false);
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (open) setMounted(true);
    else setActive(false);
  }, [open]);

  useEffect(() => {
    if (!mounted || !open || active) return;
    nodeRef.current?.getBoundingClientRect();
    requestAnimationFrame(() => setActive(true));
  }, [mounted, open, active, nodeRef]);

  const unmount = useCallback(() => setMounted(false), []);

  return { mounted, active, unmount } as const;
}
